// src/lib/session.ts
//
// Hook único de sessão para as telas: expõe a identidade, o gating por
// CAPABILITY (o back concede) e por FEATURE FLAG (efetivo do sujeito). Anti-
// botão-falso: a UI só habilita o que `hasCapability`/`hasFeature` confirmam.
import { useQuery } from "@tanstack/react-query";
import { getSession, sessionQueryKey, type OrgRole } from "@/api";
import { featureEnabled } from "@/lib/access";
import { isFeatureVisible } from "@/lib/feature-visibility";

export function useSession() {
  const q = useQuery({ queryKey: sessionQueryKey, queryFn: getSession });
  const session = q.data;
  const capabilities = new Set(session?.capabilities.map((c) => c.slug) ?? []);
  const features = session?.features ?? {};
  return {
    session,
    isPending: q.isPending,
    role: (session?.identity.role ?? null) as OrgRole | null,
    tenantId: session?.identity.tenantId ?? null,
    hasCapability: (slug: string) => capabilities.has(slug),
    // Opt-in estrito: ligado só quando o flag existe E é true. Use para habilitar
    // uma funcionalidade nova que ainda não é padrão.
    hasFeature: (flag: string) => isFeatureVisible(flag) && features[flag] === true,
    // Default-on, respeitando a pausa de interface e os flags efetivos da sessão.
    featureEnabled: (flag: string) => featureEnabled(session, flag),
  };
}
